import React from "react";
import Tilt from "react-parallax-tilt";
import { motion } from "framer-motion";

import { styles } from "../styles";
import { SectionWrapper } from "../hoc";
import { backed } from "../constants";
import { fadeIn, textVariant } from "../utils/motion";

const ProjectCard = ({ index, name, description, image }) => {
  return (
    <motion.div variants={fadeIn("up", "spring", index * 0.5, 0.75)}>
      <Tilt
        options={{
          max: 45,
          scale: 1,
          speed: 450,
        }}
        className="bg-white  shadow-card p-5 rounded-2xl sm:w-[360px] w-full min-h-0 sm:min-h-[400px]"
      >
        <div className="relative  w-full h-[230px]">
          <img
            src={image}
            alt="project_image"
            className="w-full h-full object-contain rounded-2xl"
          />
        </div>
        <p className="mt-2 text-primary text-md">{description}</p>
      </Tilt>
    </motion.div>
  );
};

const Backedby = () => {
  return (
    <>
      <motion.div
        className="flex items-center text-center justify-center"
        variants={textVariant()}
      >
        <h2 className={`${styles.sectionHeadText}`}>Backed By</h2>
      </motion.div>

      <div className="w-full flex justify-center">
        {/* <motion.p
          variants={fadeIn("", "", 0.1, 1)}
          className='mt-3 text-secondary text-xl text-center max-w-3xl leading-[30px]'
        >
          Powered by Startup-India's support, our services are best in class for your satisfaction.
        </motion.p> */}
      </div>

      <div className="mt-20 flex items-center justify-center flex-wrap gap-7">
        {backed.map((project, index) => (
          <ProjectCard key={`project-${index}`} index={index} {...project} />
        ))}
      </div>
    </>
  );
};

export default SectionWrapper(Backedby, "");
